import React from 'react';
import './NotFound.css'

const NotFound = () => {
               return (
                              // ______ NOT FOUND part _____ 
                              <div className='notfound'>
                              <div className='text-center'>
                              <img className='not-img mx-auto' 
                              src="https://wallpaperaccess.com/full/157134.jpg" alt="" />

                              </div>
                                          <h1 className="error-part text-center">404 </h1>   
                                          <p className ='error-p text-center'>Your page is not  found </p>
                                          
                              </div>
               );
};

export default NotFound;


// WEBPACK FOOTER //
// ./src/Components/NotFound/NotFound.js